import { Extension } from '@tiptap/core';
import { checkIsApple } from '@/utilities/isApple';

/**
 * This extension is used to add custom keyboard shortcuts.
 */
const customShortcuts = Extension.create({
  name: 'customShortcuts',

  addKeyboardShortcuts() {
    const shortcuts: Record<string, () => boolean> = {};

    if (checkIsApple()) {
      shortcuts['Mod-Shift-x'] = () => this.editor.commands.toggleStrike();
    } else {
      shortcuts['Ctrl-Shift-x'] = () => this.editor.commands.toggleStrike();
    }

    return shortcuts;
  },
});

export default customShortcuts;
